export default "__VITE_ASSET__BsxUk4f2__"